import type React from 'react';

import type { Workflow } from '../../types';
import { WorkflowCard } from '../workflow-card';

type WorkflowListProps = {
  workflows: Workflow[];
  onOpenEditDrawer: (workflow: Workflow) => void;
  onOpenZoomableDrawer: (workflow: Workflow) => void;
  onToggleActive: (id: string) => void;
};

export const WorkflowList: React.FC<WorkflowListProps> = ({ workflows, onOpenEditDrawer, onOpenZoomableDrawer, onToggleActive }) => {
  return (
    <>
      {workflows.map((workflow) => (
        <WorkflowCard
          key={workflow.id}
          onOpenEditDrawer={onOpenEditDrawer}
          onOpenZoomableDrawer={onOpenZoomableDrawer}
          onToggleActive={onToggleActive}
          workflow={workflow}
        />
      ))}
    </>
  );
};
